export default __webpack_public_path__ + "assets/home-one-four-small.7a8d54f6ae5b72e6c5cf10ef2418b551.png";